
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code2 } from "./data";

export default defineComponent({
  name: "max-value",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code2
    };
  }
});
